/**
 * Checks if localStorage is available and working
 * Returns false if blocked by Tracking Prevention or other browser settings
 */
export const isLocalStorageAvailable = () => {
	try {
		const testKey = '__storage_test__';
		localStorage.setItem(testKey, testKey);
		const result = localStorage.getItem(testKey);
		localStorage.removeItem(testKey);
		return result === testKey;
	} catch (e) {
		return false;
	}
};

/**
 * Gets a user-friendly message explaining how to fix storage issues
 * based on the detected browser
 */
export const getStorageBlockedMessage = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	
	if (userAgent.includes('edg/')) {
		return {
			browser: 'Microsoft Edge',
			instructions: [
				'Click the lock icon (🔒) in the address bar',
				'Click "Cookies and site permissions"',
				'Add this site to the exceptions list',
				'Or go to edge://settings/privacy → Tracking Prevention → Exceptions'
			]
		};
	}
	
	if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
		return {
			browser: 'Safari',
			instructions: [
				'Go to Safari → Preferences → Privacy',
				'Uncheck "Prevent cross-site tracking"',
				'Or add this site to the allowed list'
			]
		};
	}
	
	if (userAgent.includes('firefox')) {
		return {
			browser: 'Firefox',
			instructions: [
				'Click the shield icon in the address bar',
				'Turn off Enhanced Tracking Protection for this site',
				'Or go to about:preferences#privacy and add an exception'
			]
		};
	}
	
	return {
		browser: 'your browser',
		instructions: [
			'Check your browser\'s privacy or security settings',
			'Allow cookies and site data for this site',
			'Disable tracking prevention for this site'
		]
	};
};
